import { useState, useEffect } from 'react';
import useLatLng from "../uselatlng/uselatlng";

const useCurrentLocation = () => {

    const [location, setLocation] = useState(null);
    const islatlng = useLatLng();

    useEffect(() => {
        const message = {
            event_name: 'user_geo_location'
        }
        // const nativeObject = window.ReactNativeWebView;
        const handleMessage = (event) => {
            const message = event.data;
            if (message?.curr_lat !== undefined || message?.curr_long !== undefined) {
                // console.log("user_geo_location fired response "+JSON.stringify(message))
                setLocation({
                    lat: message?.curr_lat,
                    lng: message?.curr_long,
                    is_mock: message?.is_mock,
                });
            }
        };

        if (window!== undefined && window.ReactNativeWebView !== undefined) {
            // console.log("user_geo_location fired ")
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
            setLocation(null);
            window.addEventListener('message', handleMessage);
            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
    }, []);

    useEffect(() => {
        if (location === null && islatlng?.lat !== undefined) {
            // console.log("custom location")
            setLocation({
                lat: islatlng?.lat,
                lng: islatlng?.lng,
                is_mock: 0,
            });
        }
    }, [location, islatlng]);

    return location;
}

export default useCurrentLocation;
